<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 제목 -->
							<th class="col-1">{{ getMessage_('QWCC001438') }}</th>
							<td class="col-4">
								<el-input :value="detailForm.powPrbmTitl" @input="val => setDetailForm(val, 'powPrbmTitl', 45)" :readonly="setDisabled" />
							</td>
							<!-- 이상내용 파일첨부 -->
							<th>{{ getMessage_('QWCC001503') }}</th>
							<!-- 이상내용 이미지 첨부 1 -->
							<th>{{ getMessage_('QWCC001504') }} 1</th>
							<!-- 이상내용 이미지 첨부 2 -->
							<th>{{ getMessage_('QWCC001504') }} 2</th>
						</tr>
						<tr>
							<!-- 공정 이상 내용 -->
							<th>{{ getMessage_('QWCC001439') }}</th>
							<td>
								<el-input
									type="textarea"
									:rows="10"
									:show-word-limit="true"
									:value="detailForm.powPrbmSbc"
									@input="val => setDetailForm(val, 'powPrbmSbc', 600)"
									:readonly="setDisabled"
								/>
							</td>
							<td class="col-3 h-100">
								<template v-if="isLoaded">
									<file-upload-list
										id="powPrbmFile"
										width="100%"
										height="100%"
										:propFileList="detailForm.powPrbmFileDb"
										maxQuantity="5"
										@MultiFile="fileUpload"
										@onDownload="onDownloadFile"
										:isEditable="!setDisabled"
									></file-upload-list>
								</template>
							</td>
							<td rowspan="2" style="width: 100px">
								<template v-if="isLoaded">
									<img-upload
										ref="powImg1FileRef"
										width="100%"
										height="140px"
										:propSrc="powImg1Url"
										propSeq="powImg1File"
										:disabled="setDisabled"
										:propFileId="detailForm.powImg1FileId"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
										:isEditable="!setDisabled"
										@deleteImg="imgDelete"
										:needDupCheck="true"
										@imgDupCheck="imgDupCheck"
									>
									</img-upload>
								</template>
							</td>
							<td rowspan="2" style="width: 100px">
								<template v-if="isLoaded">
									<img-upload
										ref="powImg2FileRef"
										width="100%"
										height="140px"
										:propSrc="powImg2Url"
										propSeq="powImg2File"
										:disabled="detailForm.pgsStCd > 30 || (!powImg2Url && !powImg1Existed)"
										:propFileId="detailForm.powImg2FileId"
										@imgUpload="imgUpload"
										@imgDownload="imgDownload"
										:isEditable="!setDisabled"
										@deleteImg="imgDelete"
										:needDupCheck="true"
										@imgDupCheck="imgDupCheck"
									></img-upload>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getLimitedByteText } from '@/qmsUtils';
import ImgUpload from '@qms/Components/ImgUpload.vue';
import FileUploadList from '@qms/Components/FileUploadList.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/ptin/PowTourStts/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			isLoaded: false,
			powImg1Url: '',
			powImg2Url: '',
			powImg1FileNm: '',
			powImg2FileNm: '',
			powImg1Existed: false // 이미지 1부터 등록시키기 위해서
		};
	},
	components: { ImgUpload, FileUploadList },
	computed: {
		...rootComputed,
		...serviceComputed,
		setDisabled() {
			return !(this.isPqyStaff && this.detailForm.pgsStCd <= 20 && this.getCheckWriterSelf_);
		}
	},
	async mounted() {
		this.loadImg();
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		async setDetailForm(value, key, maxByte) {
			this.setState_({ key: 'isSaved', value: true });
			maxByte ? this.setDetailForm_({ key, value: getLimitedByteText(value, maxByte) }) : this.setDetailForm_({ key, value });
		},
		imgDupCheck({ seq, file }) {
			let isDup;
			if (seq === 'powImg1File') {
				isDup = this.powImg2FileNm == file.name;
				!isDup && (this.powImg1Existed = true);
			} else {
				isDup = this.powImg1FileNm == file.name;
			}

			if (!isDup) {
				this.$refs[seq + 'Ref'].imgUpload();
			} else {
				this.$sf_toast({ type: 'error', title: 'Warning', message: this.getMessage_('QWCC001869') }); //파일 이름이 같을 경우 업로드가 제한됩니다.
			}
		},
		imgUpload({ seq, file }) {
			this.setDetailForm_({ key: seq, value: file });
			this[seq + 'Nm'] = file.name;
		},
		fileUpload(saveList) {
			this.setState_({ key: 'isSaved', value: true });
			this.setDetailForm_({ key: 'powPrbmFile', value: saveList });
		},
		imgDelete({ seq }) {
			this[seq + 'Nm'] = '';
			this.setDetailForm_({ key: seq + 'Id', value: '' });
			this.setDetailForm_({ key: seq + 'Db', value: null });
			this.setDetailForm_({ key: seq, value: null });
			if (seq === 'powImg1File') {
				this.powImg1Existed = false;
			}
		},
		async imgDownload({ seq }) {
			await this.fileDownload_({ fileId: this.detailForm[seq + 'Id'], fileSeq: 1 });
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		async loadImg() {
			this.isLoaded = false;
			const { url: powImg1Url } = this.detailForm.powImg1FileId
				? await this.imgDownload_({ fileId: this.detailForm.powImg1FileId, fileSeq: 1 })
				: '';
			const { url: powImg2Url } = this.detailForm.powImg2FileId
				? await this.imgDownload_({ fileId: this.detailForm.powImg2FileId, fileSeq: 1 })
				: '';
			if (powImg1Url) {
				this.powImg1Url = powImg1Url;
				this.powImg1Existed = true; // 이화면에서만 쓰는 변수
				this.powImg1FileNm = this.detailForm.powImg1FileDb.origFileName;
			}
			if (powImg2Url) {
				this.powImg2Url = powImg2Url;
				this.powImg2FileNm = this.detailForm.powImg2FileDb.origFileName;
			}
			this.isLoaded = true;
		},
		initImgAll(seq) {
			//이미지 컴포넌트 초기화
			if (!seq) {
				this.powImg1Url = '';
				this.powImg2Url = '';
				this.powImg1FileNm = '';
				this.powImg2FileNm = '';
				this.$refs.powImg1FileRef?.initImg();
				this.$refs.powImg2FileRef?.initImg();
			} else {
				this[seq + 'Url'] = '';
				this[seq + 'Nm'] = '';
				this.$refs[seq + 'Ref'].initImg();
			}
		}
	}
};
</script>

<style></style>
